import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check if user is authenticated
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  // Check if user has admin privileges
  if (!currentUser.is_admin) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default AdminRoute; 